import { Button, Center, HStack, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalOverlay, Text, } from "@reverb-ui/react";
import React from "react";
var ActionModal = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, onConfirm = _a.onConfirm, title = _a.title, subtitleFirstPart = _a.subtitleFirstPart, subtitleLastPart = _a.subtitleLastPart, employeeSelected = _a.employeeSelected, icon = _a.icon, buttonCancel = _a.buttonCancel, buttonConfirm = _a.buttonConfirm;
    var generationModalSubtitle = function () {
        return subtitleFirstPart + " " + employeeSelected + " " + subtitleLastPart;
    };
    return (React.createElement(Modal, { isOpen: isOpen, onClose: onClose, size: "lg" },
        React.createElement(ModalOverlay, null),
        React.createElement(ModalContent, null,
            React.createElement(ModalCloseButton, null),
            React.createElement(ModalBody, { overflow: "auto" },
                React.createElement(Center, { my: "8" }, icon),
                React.createElement(Text, { align: "center", marginTop: "30px" },
                    React.createElement(Text, { fontSize: "xl", as: "strong" }, title),
                    React.createElement(Text, { fontSize: "sm", marginTop: "30px" }, generationModalSubtitle()))),
            React.createElement(ModalFooter, { alignSelf: "right", marginTop: "30px" },
                React.createElement(HStack, { spacing: 4, align: "center" },
                    React.createElement(Button, { borderColor: "blue.500", variant: "outline", colorScheme: "blue", color: "blue.500", onClick: onClose, title: "Cancel" }, buttonCancel),
                    React.createElement(Button, { colorScheme: "blue", onClick: onConfirm, title: "Confirm" }, buttonConfirm))))));
};
export default ActionModal;
